import { ApiClient } from './client';
import { setAuthToken } from '@/lib/utils';
import { publicEndpoints } from '@/lib/endpoints';
import type { AuthTokenResponse } from '@/lib/types/authentication';

const PUBLIC_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';
// const PUBLIC_BASE_URL = 'http://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';

const client = new ApiClient(PUBLIC_BASE_URL);

const ensureGuestToken = async () => {
  // Skip token logic during server-side rendering / static generation
  if (typeof window === "undefined") {
    return;
  }
  
  const auth_token = localStorage.getItem('auth_token')
  if (!auth_token) {
    const response = await client.post<AuthTokenResponse>(publicEndpoints.auth.login, { 
      is_guest: true, 
      username: null, 
      email: null, 
      password: null 
    });
    if (!response.data) return;
    const token = response.data.token;
    if (token) setAuthToken(token);
    return;
  }
};

export const orderApi = {
  get: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.get<T>(endpoint);
  },
  post: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.post<T>(endpoint, data);
  },
  put: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.put<T>(endpoint, data);
  },
  patch: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.patch<T>(endpoint, data);
  },
  delete: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.delete<T>(endpoint);
  },
};